import { createRouter, createWebHistory } from 'vue-router'
import Login from '@/views/Login.vue'
import Dashboard from '@/views/Dashboard.vue'
import CustomerManagement from '@/views/CustomerManagement.vue'
import OrderManagement from '@/views/OrderManagement.vue'
import DataAnalysis from '@/views/DataAnalysis.vue'
import DepartmentManagement from '@/views/DepartmentManagement.vue'
import LeadManagement from '@/views/LeadManagement.vue'
import OpportunityManagement from '@/views/OpportunityManagement.vue';
import ApprovalManagement from '@/views/ApprovalManagement.vue';
import QuotationManagement from '@/views/QuotationManagement.vue';
import ProductManagement from '@/views/ProductManagement.vue'
import ApprovalProcessManagement from '@/views/ApprovalProcessManagement.vue'
import ContractManagement from '@/views/ContractManagement.vue'
import PaymentManagement from '@/views/PaymentManagement.vue'
import UserManagement from '@/views/UserManagement.vue'
import UserDetail from '@/views/UserDetail.vue'
import AnnualPlan from '@/views/AnnualPlan.vue'
import StatisticsManagement from '@/views/StatisticsManagement.vue'
import CustomerApproval from '@/views/CustomerApproval.vue'
const router = createRouter({
  history: createWebHistory('/'),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { 
        title: '登录',
        requiresAuth: false,
        hideInMenu: true,
        layout: 'blank'
      }
    },
    {
      path: '/',
      component: () => import('@/layouts/MainLayout.vue'),
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          redirect: '/dashboard'
        },
        {
          path: 'dashboard',
          name: 'dashboard',
          component: Dashboard,
          meta: { title: '首页' }
        },
        {
          path: 'customers',
          name: 'customers',
          component: CustomerManagement,
          meta: { title: '客户管理' }
        },
        {
          path: 'orders',
          name: 'orders',
          component: OrderManagement,
          meta: { title: '订单管理' }
        },
        {
          path: 'departments',
          name: 'departments',
          component: DepartmentManagement,
          meta: { title: '部门管理' }
        },
        {
          path: 'leads',
          name: 'leads',
          component: LeadManagement,
          meta: { title: '线索管理' }
        },
        {
          path: 'analysis',
          name: 'analysis',
          component: DataAnalysis,
          meta: { title: '数据分析' }
        },
        {
          path: 'business',
          name: 'business',
          component: OpportunityManagement,
          meta: { title: '商机管理' }
        },{
          path: 'approval',
          name: 'approval',
          component: ApprovalManagement,
          meta: { title: '审批管理' }
        },{
          path: 'quotation',
          name: 'quotation',
          component: QuotationManagement,
          meta: { title: '报价管理' }
        },{
          path: 'product',
          name: 'product',
          component: ProductManagement,
          meta: { title: '产品管理' }
        },{
          path: 'approvalProcess',
          name: 'approvalProcess',
          component: ApprovalProcessManagement,
          meta: { title: '审批流程管理' }
        },{
          path: 'contract',
          name: 'contract',
          component: ContractManagement,
          meta: { title: '合同管理' }
        },{
          path: 'payment',
          name: 'payment',
          component: PaymentManagement,
          meta: { title: '付款管理' }
        },{
          path: 'user',
          name: 'user',
          component: UserManagement,
          meta: { title: '用户管理' }
        },{
          path: 'user/detail',
          name: 'userDetail',
          component: UserDetail,
          meta: { title: '用户详情' }
        },
        {
          path: 'annual-plan',
          name: 'annualPlan',
          component: AnnualPlan,
          meta: { title: '年度计划' }
        },
        {
          path: 'statistics',
          name: 'statistics',
          component: StatisticsManagement,
          meta: { title: '统计管理' }
        },
        {
          path: 'customerApproval',
          name: 'customerApproval',
          component: CustomerApproval,
          meta: { title: '客户编辑' }
        }
      ]
    }
  ]
})

// 优化路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  // 如果访问登录页
  if (to.path === '/login') {
    if (token) {
      // 已登录则重定向到首页
      next('/dashboard')
    } else {
      // 未登录则允许访问登录页
      next()
    }
    return
  }

  // 如果需要认证
  if (requiresAuth) {
    if (token) {
      // 已登录则允许访问
      next()
    } else {
      // 未登录则重定向到登录页
      next({
        path: '/login',
        query: { redirect: to.fullPath } // 保存原目标路径
      })
    }
    return
  }

  // 其他情况直接放行
  next()
})

export default router 